export default "__VITE_ASSET__DCrgrRrD__"